const temporaryStorage = {};

export default {
    setItem: (key, value) => {
        try {
            window.localStorage.setItem(key, value);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            temporaryStorage[key] = value;
        }
    },
    getItem: (key) => {
        let value;

        try {
            value = window.localStorage.getItem(key);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            value = temporaryStorage[key];
        }

        return value;
    },
    removeItem: (key) => {
        try {
            window.localStorage.removeItem(key);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            delete temporaryStorage[key];
        }
    }
};
